var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPipe5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 350,
    height: 165,
    viewBox: "0 0 350 165",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305 44.8878C305 50.1345 300.747 54.3878 295.5 54.3878L54.5 54.3878C24.4005 54.3878 -3.76844e-06 78.7882 -2.45275e-06 108.888L0 165L45 165L45 108.888C45 103.641 49.2533 99.3878 54.5 99.3878L295.5 99.3878C325.6 99.3878 350 74.9873 350 44.8877L350 0L305 1.72258e-05L305 44.8878Z",
    fill: "#BED4ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168 76.4814L184.797 57.0118L184.797 95.9509L168 76.4814Z",
    fill: "url(#paint0_linear_12_73)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M181.396 76.4999L198.194 57.0304L198.194 95.9695L181.396 76.4999Z",
    fill: "url(#paint1_linear_12_73)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M194.793 76.5186L211.59 57.0491L211.59 95.9882L194.793 76.5186Z",
    fill: "url(#paint2_linear_12_73)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9819 148.189L2.94501 131.392L41.0187 131.392L21.9819 148.189Z",
    fill: "url(#paint3_linear_12_73)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 134.793L2.96317 117.996L41.0369 117.996L22 134.793Z",
    fill: "url(#paint4_linear_12_73)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0181 121.397L2.9813 104.6L41.055 104.6L22.0181 121.397Z",
    fill: "url(#paint5_linear_12_73)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_73",
    x1: 168,
    y1: 76.4814,
    x2: 190.396,
    y2: 76.4814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_73",
    x1: 181.396,
    y1: 76.4999,
    x2: 203.793,
    y2: 76.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12_73",
    x1: 194.793,
    y1: 76.5186,
    x2: 217.189,
    y2: 76.5186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12_73",
    x1: 21.9819,
    y1: 148.189,
    x2: 21.9819,
    y2: 125.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12_73",
    x1: 22,
    y1: 134.793,
    x2: 22,
    y2: 112.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12_73",
    x1: 22.0181,
    y1: 121.397,
    x2: 22.0181,
    y2: 99.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipe5);
export default __webpack_public_path__ + "static/media/pipe-5.2f75472627c7f3852c63d9e95624e345.svg";
export { ForwardRef as ReactComponent };